import { render, staticRenderFns } from "./SettingsAddress.vue?vue&type=template&id=40936b15&scoped=true"
import script from "./SettingsAddress.vue?vue&type=script&lang=js"
export * from "./SettingsAddress.vue?vue&type=script&lang=js"
import style0 from "./SettingsAddress.vue?vue&type=style&index=0&id=40936b15&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40936b15",
  null
  
)

export default component.exports